var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-news-wrap"},[_c('div',{staticClass:"featured-news-wrap"},[_c('FeaturedNews',{attrs:{"ispage":true}}),_c('NewsArticles')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }